import React from "react";
import { Row, Col } from "react-bootstrap";
import { Progress } from "rsuite";
import { useTranslation } from "react-i18next";
import Chart from "./Chart";
import Stat from "./Stat";
import Booking from "./Booking";
const Common = (props) => {
  const product = props.product;
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col xl="6" className="my-3">
          <div className="bg-white border rounded p-3 h-100">
            <Row className="justify-content-between align-items-end">
              <Col xl="9">
                <div className="fs-4 fw-medium text-dark">{product.name}</div>

                <div className="fs-5 text-capitalize my-2">
                  {product.type?.name ?? t("unknown_type")}
                </div>

                <p className="fs-6 fw-light my-2">
                  {t("created_the")} : {product.created_at}
                </p>

                <div className="mt-3">
                  <Progress.Line
                    className="p-0"
                    percent={product.percentage ?? 0}
                    strokeColor="#8077EC"
                  />
                </div>
              </Col>

              <Col xl="2">
                <div className="fs-6 fw-light text-blue">{t("continue")}</div>
              </Col>
            </Row>
          </div>
        </Col>
        {/* Total Benefits */}
        <Col md="6" xl="3" className="my-3">
          <div className="rounded text-white text-center bg-blue h-100 p-5">
            <div className="fs-1 fw-medium">
              {product?.amount ?? 0} {props.profile.provider?.currency}
            </div>
            <p className="fs-5 fw-light">
              {t("total_benefits_for_this_product")}
            </p>
          </div>
        </Col>

        {/* Total Bookings */}
        <Col md="6" xl="3" className="my-3">
          <div className="rounded text-dark text-center bg-orange h-100 p-5">
            <div className="fs-1 fw-medium">{product?.bookings ?? 0}</div>
            <p className="fs-5 fw-light">
              {t("total_bookings_for_this_product")}
            </p>
          </div>
        </Col>
      </Row>

      <Row>
        <Col xl="9" className="my-2">
          <Chart t={t} product_id={product.id} />
        </Col>
        <Col xl="3">
          <Stat t={t} product_id={product.id} />
        </Col>
      </Row>

      <Row>
        <Col xl="12" className="my-2">
          <div className="bg-white border p-3">
            <Booking
              t={t}
              product_id={product.id}
              service={product.service}
              country={product.country.id}
              {...props}
            />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Common;
